import React, { Component } from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'

export default class Dailyui extends Component {
    constructor(props){
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        
        return (
            <div className="row" id="body">
                    
            <div className="col-12 mx-0 col-lg-10" id="content">

                <div className="row pt-4" id="ui_design">
                    <div className="col-12">
                      <img id="Day_1_5" width="100%" src={require('../../../Images/Daily_project/Daily_ui/Day_1_5.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12">
                      <img id="Day_6_10" width="100%" src={require('../../../Images/Daily_project/Daily_ui/Day_6_10.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12">
                      <img id="Day_11_15" width="100%" src={require('../../../Images/Daily_project/Daily_ui/Day_11_15.png')} alt="Case_studies_2" />
                    </div>
                </div>
            </div>
                    
            <div className="col-lg-2 d-none d-lg-block px-4 pt-4 h-25 sticky-top" id="sidebar" style={{top: "56px"}}>

                <p className="h4">Days</p>
                <p>
                  <AnchorLink href="#Day_1_5" className="bullet">1-5</AnchorLink>
                  <br />
                  <AnchorLink href="#Day_6_10" className="bullet">6-10</AnchorLink>
                  <br />
                  <AnchorLink href="#Day_11_15" className="bullet">11-15</AnchorLink>
                </p>

                <div className="row pt-4 px-3">
                <p className="h4">TOOLS</p>

                <div className="col-12 px-2">
                  <div className="row">
                          <img width="25%" className="tools" src={require('../../../Images/Tools/xd.png')} alt="Case_studies_1" />
                  </div>
                </div>
                
              </div>
                

            </div>

            
                  
            </div>
    )
}
}